import { Form } from "antd"
import { Button, Modal, RadioButtons, SelectInput } from "components/common"
import Flex from "components/common/flex"
import { useLazyGetUsersQuery } from "features/shared/api"
import { useQueryUpdate } from "hooks"
import { t } from "i18next"
import { forwardRef, useMemo } from "react"

const ShareLeadWithMortgage = forwardRef(({ form, onOk, resetAll, onClickBack, loading, leadId }, ref) => {
  const [getUsers, { data: usersData }] = useLazyGetUsersQuery()
  const [updateQueryData] = useQueryUpdate()
  const sharingTypes = useMemo(() => [{ label: t("Manual"), value: "manual" }], [])

  const handleSubmit = values => {
    onOk(values)
  }

  const onModalVisible = () => {
    getUsers({
      teamType: ["mortgage"],
      leadShare: true,
      privileged: false,
      inquiryId: leadId
    })
  }

  return (
    <Modal
      ref={ref}
      title={t("Share Lead")}
      onOk={form?.submit}
      onCancel={() => {
        resetAll()
        updateQueryData("getMortgageAssessment", draft => null)
      }}
      okText={t("Share Lead")}
      onModalVisible={onModalVisible}
      destroyOnClose={true}
      maskClosable={false}
      footer={
        <Flex justify="end" gap="8px">
          <Button size="large" type="default" key="back" onClick={onClickBack} text={t("Back")} />
          <Button size="large" key="submit" type="primary" onClick={() => form.submit()} text={t("Next")} />
        </Flex>
      }
      loading={loading}
    >
      <Form
        form={form}
        layout="vertical"
        name="mortgage-sharing-form"
        initialValues={{ sharingType: "manual" }}
        onFinish={handleSubmit}
      >
        <Form.Item
          label={t("Sharing Type")}
          name="sharingType"
          rules={[{ required: true, message: t("Please select a sharing type") }]}
        >
          <RadioButtons
            options={sharingTypes}
            value={form?.getFieldValue("sharingType")}
            onChange={value => form?.setFieldsValue({ sharingType: value })}
          />
        </Form.Item>

        <Form.Item label={t("User")} name="userId" rules={[{ required: true, message: t("Please select a user") }]}>
          <SelectInput options={usersData || []} value={form?.getFieldValue("userId")} placeholder={t("Select User")} />
        </Form.Item>
      </Form>
    </Modal>
  )
})

export default ShareLeadWithMortgage
